import { lazy } from 'react';

const NominationMarketerConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/marketer/consult/nomination-info',
			component: lazy(() => import('./NominationContainer'))
		}
	]
};

export default NominationMarketerConfig;



